import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * Redirects a legacy path to its new home, carrying the route params, query
 * string, and hash across.
 *
 * `<Navigate to="/admin-tools/mockups/:mockupId" />` would navigate to that
 * literal string, so the params are substituted here from the matched route.
 * Bookmarks and pasted links to the pre-move paths have to keep working.
 */
export const RedirectTo: React.FunctionComponent<{ to: string }> = ({ to }): JSX.Element => {
    const params = useParams();
    const { search, hash } = useLocation();

    const target = to.replace(
        /:([A-Za-z_][A-Za-z0-9_]*)/g,
        (match: string, name: string) => params[name] ?? match
    );

    return <Navigate to={`${target}${search}${hash}`} replace />;
};
